import styled from '@emotion/styled';

import {HelpTooltip} from '@/components/HelpTooltip';
import {NewFeatureBadge} from '@/components/NewFeatureBadge';

export const Headline = styled.div`
  text-wrap: balance;

  ${NewFeatureBadge} {
    margin-right: 8px;
  }

  ${HelpTooltip} {
    margin-left: 4px;
  }
`;
